import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 10,
	viewBox: "0 0 18 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5938 0.699707H17.5547C17.6328 0.777832 17.7109 0.89502 17.7109 1.01221C17.7109 1.16846 17.6328 1.28564 17.5547 1.36377L9.3125 9.60596C9.23438 9.68408 9.11719 9.72314 9 9.72314C8.84375 9.72314 8.72656 9.68408 8.64844 9.60596L0.40625 1.36377C0.328125 1.28564 0.289062 1.16846 0.289062 1.01221C0.289062 0.89502 0.328125 0.777832 0.40625 0.699707L0.71875 0.387207C0.796875 0.309082 0.875 0.27002 1.03125 0.27002C1.14844 0.27002 1.26562 0.309082 1.38281 0.387207L9 8.04346L16.6172 0.387207C16.6953 0.309082 16.8125 0.27002 16.9688 0.27002C17.0859 0.27002 17.2031 0.309082 17.2812 0.387207L17.5938 0.699707Z",
		fill: "currentColor"
	})
});
export default SvgChevronDown;
